import type { ReactNode } from 'react'
import { Redirect } from 'wouter'
import { useAuth } from './useAuth'

interface Props {
  children: ReactNode
}

export default function RequireAuth({ children }: Props) {
  const { user, loading, error } = useAuth()

  if (loading) {
    return null
  }

  if (error) {
    return <div className="container">Unable to verify authentication. Please refresh the page.</div>
  }

  if (user === null) {
    return <Redirect to="/login" />
  }

  return <>{children}</>
}
